import { Util } from '@grandvisionhq/forms'

const { isValidPostalCodeForCountry } = Util.validations

export const isValidPostalCode = (value: string): boolean =>
  isValidPostalCodeForCountry('GB', value)

export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)

const REGEX = {
  WHITESPACE: /\s/g,
  ORDER_NUMBER: /^2\d{9}$/,
}
